export default {"src":"/_next/static/media/arrow-down.aba26d84.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};